import * as React from 'react';
import {Icon} from '@chakra-ui/react';
import {
	MdCalendarToday,
	MdInfoOutline,
	MdKeyboardArrowDown,
	MdKeyboardArrowUp,
} from 'react-icons/md';

type IconProps = {
	[key: string]: any;
};

const makeIcon = (icon: React.ElementType) =>
	React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
		<Icon ref={ref} as={icon} {...props} />
	));

export const CalendarIcon = makeIcon(MdCalendarToday);
export const InfoIcon = makeIcon(MdInfoOutline);
export const ChevronDownIcon = makeIcon(MdKeyboardArrowDown);
export const ChevronUpIcon = makeIcon(MdKeyboardArrowUp);
